import {MatchPlayer} from "@app/core/match-player/domain/model/match-player";

const KEY_EMAIL = "email";
const KEY_NAME = "name";

export class MatchPlayerMapper {
    static deserialize(data:Record<string, any>) {
        return new MatchPlayer(
            data[KEY_EMAIL],
            data[KEY_NAME],
        )
    }
}
